/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Company } from '../../models/company';
import { CriteriaCompany } from '../../models/criteria-company';

export interface ApiMasterCompanyGetByCriteriaPost$Params {
      body?: CriteriaCompany
}

export function apiMasterCompanyGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterCompanyGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCompanyGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Company>>;
    })
  );
}

apiMasterCompanyGetByCriteriaPost.PATH = '/api/Master/Company/GetByCriteria';
